<style lang="less">
    .scrapRecord{
        border: 1px solid #d7dde4;
        background: #efefef;
        height: 100%;
        position: relative;
        .head{
            height: 46px;
            padding-top: 10px;
            margin-bottom: 20px;
            h1{
                display: inline;
                margin-left: 20px;
                };
            .searchArea{
                display: inline-block;
                margin-left: 20px;
            }
        }
        .layout-breadcrumb{
            padding: 10px 15px 0px ;
            /*border-bottom: 1px solid #e3e3e3;*/
        }
        .layout-content{
            min-height: 80vh;
            margin: 15px;
            overflow: hidden;
            background: #fff;
            border-radius: 4px;
        }
        .layout-content-main{
            padding: 10px;
        }
        .table th{
            background-color: #00c0ff;
            color: #fff;
        }
        .footer{
            margin-top: 10px;
            width: 100%;
            height: 46px;
        }

    }
    .ivu-table .demo-table-info-row td{
        color: #f50807;
    }



</style>
<template>
    <div class="scrapRecord">
        <Row>
            <i-col span="24">
                <div class="layout-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem >资产管理</BreadcrumbItem>
                        <BreadcrumbItem >报废记录列表</BreadcrumbItem>
                    </Breadcrumb>
                </div>
                <div class="layout-content">
                    <div class="layout-content-main">
                        <div class="head">
                            <h1 >报废记录列表</h1>
                            <div class="searchArea">
                                部门:
                                <Select v-model="scrap_department" clearable style="width:162px;display: inline-block">
                                    <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                </Select>
                                状态:
                                <Select v-model="ql_type" clearable style="width:162px;display: inline-block">
                                    <Option value="待报废">待报废</Option>
                                    <Option value="已报废">已报废</Option>
                                </Select>
                                <Button type="primary" @click="search">查询</Button>

                            </div>
                        </div>
                        <Table border :columns="columns1" class="table" :row-class-name="rowClassName"  :data="dataSourceList" ref="table"></Table>
                        <Modal v-model="modal_change" width="500">
                            <h1 slot="header" style="text-align: center;color: #00c0ff">更改报废状态</h1>
                            <div class="main">
                                <div >
                                    <span class="ivu-form-item-label" style="font-size: 18px;">资产名称：</span>
                                    <p style="font-size: 18px;display: inline-block">{{scrap_name}}</p>
                                </div>
                                <div style="margin-top: 20px;">
                                    <span class="ivu-form-item-label" style="font-size: 18px;">所属部门：</span>
                                    <p style="font-size: 18px;display: inline-block">{{scrap_dep}}</p>
                                </div>
                                <div style="margin-top: 20px;">
                                    <span class="ivu-form-item-label" style="font-size: 18px;">报废状态：</span>
                                    <Select v-model="scrap_type" clearable style="width:162px;display: inline-block">
                                        <Option value="待报废">待报废</Option>
                                        <Option value="已报废">已报废</Option>
                                        <Option value="在用">在用</Option>
                                    </Select>
                                </div>
                            </div>
                            <div slot="footer">
                                <Button @click="modal_change=false">取消</Button>
                                <Button type="primary" @click="changeState">确定</Button>
                            </div>
                        </Modal>
                    </div>
                </div>
                <div class="footer">
                    <Page
                            class="pull-right"
                            :total="totalSize"
                            :current="page"
                            size="small"
                            show-total
                            @on-change="changePage"
                            :page-size='pageSize'
                    ></Page>
                </div>

            </i-col>

        </Row>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                loadDataUrl:'manage/waterrec/weixin_list',
                percent: 0,
                username:'',
                startDate:'',
                endDate:'',
                scrap_type:'',
                scrap_name:'',
                scrap_dep:'',
                change_index:'',
                scrap_department:'',
                ql_type:'',
                modal_change:false,
                recordPage: {
                    current: 1,
                    pageSize: 20,
                    total: 0
                },
                totalSize:0,
                pageSize:14,
                page:1,
                dataSourceList:[],
                departmentList:[],
                columns1: [
//                    {
//                        title: '用友系统卡片编号',
//                        key: 'DataTime',
//                        align: 'center'
//                    },
                    {
                        title: '用友系统卡片编号',
                        key: 'yonyou_id',
                        align: 'center'
                    },
                    {
                        title: '固定资产名称',
                        key: 'name',
                        align: 'center'
                    },
                    {
                        title: '所属科室',
                        key: 'department',
                        align: 'center'
                    },
                    {
                        title: '增加日期',
                        key: 'insert_time',
                        align: 'center',
                    },
                    {
                        title: '资产原值（元）',
                        key: 'full_price',
                        align: 'center'
                    },
                    {
                        title: '报废状态',
                        key: 'type',
                        align: 'center'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                        let rowData = params.row;
                        return h('div', [
                            h('Button', {
                                props: {
                                    size: 'small',
                                    type: 'warning',
                                },
                                style: {
                                    marginRight: '5px',
                                },
                                on: {
                                    click: () => {
                                    this.change(params.index)
                            }
        }
                            }, '更改状态'),
                        ]);

                        }
                    },

                ],
            }

        },
        methods: {
            //渲染未归还行颜色
            rowClassName (row,index) {
                var that =this;
                for(var i=0;i<this.dataSourceList.length;i++){
                    if(that.dataSourceList[i].type=="已报废"&& index == i){
                        return 'demo-table-info-row';
                    }
                }
            },
            //部门列表
            getDepartment:function () {
                var that = this;
                var params = {};
                params.data = {};
                params.token = this.getKey('token');
                params.url = '/sys/department/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.departmentList = res.data.result.result;
//                    that.recordPage.total = res.result.totalSize
//                    that.dataSourceList.reverse()

                }
                this.ajaxPost(params);
            },

            //查询
            search:function (page) {
                var that=this;
                var params = {};
                if(this.scrap_department==undefined){
                    this.scrap_department='';
                }
                if(this.ql_type==undefined){
                    this.ql_type='';
                }
                params.data = {
//                    department:that.scrap_department,
//                    type:that.ql_type
                    "searchValue":{department:that.scrap_department+'|#|like',type:that.ql_type+'|#|like'},
//                    "order":{"DataTime":-1},
                    pageSize:this.pageSize,

                };
              if(page === undefined || page === "" || isNaN(page)){
                params.data.page = 1;
              }else{
                params.data.page = page;
              }
                params.token = this.getKey('token');
                params.url = '/sys/scraprecord/list';
                console.log(params.data);
                params.success = function(res) {
                    console.log(res);
                    that.$Loading.finish();
                    that.totalSize=res.data.result.totalSize;
                    that.page=res.data.result.page;
                    that.dataSourceList = res.data.result.result;
//                    for(let item in that.dataSourceList){
//                        if(that.dataSourceList[item].type=='true'){
//                            that.dataSourceList[item].type='已报废'
//                        }else if(that.dataSourceList[item].type=='false'){
//                            that.dataSourceList[item].type='待报废'
//                        }
//                    }
                }
                this.ajaxPost(params);
            },
            //加载数据
            loadData: function(page){
                var that = this;
                var params = {};
                page = page == '' || page == undefined?this.page:page;
                params.data = {
//                    "searchValue":{DataTime:that.startDate+' 00:00:00 |#|'+that.endDate+' 23:59:59'},
                    "order":{"_id":-1},
                    pageSize:this.pageSize,
                    page:page
                };
                if(page === undefined || page === "" || isNaN(page)){
                    params.data.page = 1;
                }else{
                    params.data.page = page;
                }
                params.token = this.getKey('token');
                params.url = '/sys/scraprecord/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.totalSize=res.data.result.totalSize;
                    that.page=res.data.result.page;
                    that.dataSourceList = res.data.result.result;
//                    for(let item in that.dataSourceList){
//                        if(that.dataSourceList[item].type=='true'){
//                            that.dataSourceList[item].type='已报废'
//                        }else if(that.dataSourceList[item].type=='false'){
//                            that.dataSourceList[item].type='待报废'
//                        }
//                    }

                }
                this.ajaxPost(params);

            },
            change:function (index) {
                this.modal_change=true;
                this.change_index=index;
                this.scrap_type=this.dataSourceList[index].type;
                this.scrap_dep=this.dataSourceList[index].department;
                this.scrap_name=this.dataSourceList[index].name;
            },
            changeState:function () {
                var that = this;
                var params = {};
                params.data = {
                    id:this.dataSourceList[this.change_index].id,
                    _id:this.dataSourceList[this.change_index]._id,
                    type:this.scrap_type
                };
                params.token = this.getKey('token');
                params.url = '/sys/scraprecord/edit';
                console.log(params.data);
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.$Notice.success({
                        title: '修改成功'
                    });
                    that.modal_change=false;
                    that.change_index='';
                    that.loadData()
//                    that.totalSize=res.result.totalSize;
//                    that.page=res.result.page;

                }
                this.ajaxPost(params);
            },
            changePage: function(page) {
                this.search(page);
            },
        },
        mounted: function () {
//            console.log(555);
//            console.log(888);
//            this.endDate=new Date().format('yyyy-MM-dd');
//            this.startDate=new Date(new Date(this.endDate).getTime()-24*60*60*1000).format('yyyy-MM-dd');
            this.loadData();
            this. getDepartment()

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/propertyMana/scrapRecord.vue